import { lazy, Suspense } from 'react';

import { Skeleton } from '@recruit-robin/robin-theme/web-components';

import { Row } from 'components/ui/atoms';
import { useStyles } from '../CandidateDetailsHeaderInfo/styles';
import type { CandidateActionButtonsProps } from './CandidateActionButtons.types';

const CandidateActionButtonsLazy = lazy(() =>
  import('./CandidateActionButtons').then((module) => ({ default: module.CandidateActionButtons })),
);

export function CandidateActionButtons(props: CandidateActionButtonsProps) {
  const classes = useStyles();
  const loading = (
    <Row css={classes.actionButtonsWrapper}>
      <Skeleton variant="square" width={34} height={34} />
      <Skeleton variant="square" width={34} height={34} />
    </Row>
  );
  if (props.isLoading) {
    return loading;
  }
  return (
    <Suspense fallback={loading}>
      <CandidateActionButtonsLazy {...props} />
    </Suspense>
  );
}
